module.exports = __webpack_public_path__ + "static/header2-44e7b9b6214134a5451f7d390400d5ee.jpg";